import { useAuthTokens, UserRole } from "modules/auth";
import { Navigate } from "react-router-dom";

interface ManagerPrivateRouteProps {
  children: JSX.Element;
}

const ManagerPrivateRoute = ({ children }: ManagerPrivateRouteProps) => {
  const { accessToken, role } = useAuthTokens();

  if (!accessToken) return <Navigate to="/login" replace />;

  if (role !== UserRole.DeliveryCompany && role !== UserRole.CompanyManager) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ManagerPrivateRoute;
